<ng-container *ngIf="traitement; else noTraitement">
  <div class="traitement-status">
    <dx-button id="traitement-button"
      [text]="getButtonText()"
      [type]="getButtonType()"
      icon="info"
      [disabled]="loading"
      (onClick)="openMetadataDialog()">
    </dx-button>
  </div>
  
  <dx-popup 
    [(visible)]="popupVisible" 
    [dragEnabled]="false" 
    [closeOnOutsideClick]="true" 
    [showCloseButton]="true"
    [height]="800" 
    [width]="800" 
    [title]="'Traitement N°' + traitement?.id">
      <div *dxTemplate="let data of 'content'">
          <div class="popup-header">
              <p class="popup-header-title">{{ traitement.intitule }}</p>
              <p>Démarré le <b>{{ traitement.dateDebut | date:'dd/MM/yyyy à HH:mm:ss' }}</b> ; par <b>{{ traitement.createur}}</b></p>
              <p class="popup-header-result">Résultat : <b>{{ getResultatText() }}</b></p>
          </div>
  
          <!-- Affichage du message d'erreur détaillé -->
          <div *ngIf="traitement?.resultat === ResultatTraitement.erreur || traitement?.resultat === ResultatTraitement.echec"
              class="error-message-container">
              <div class="error-message-header">Message d'erreur:</div>
              <div class="error-message">{{ getErrorMessage() }}</div>
          </div>
  
          <!-- Détails complets des métadonnées -->
          <div class="metadata-container">
              <div class="metadata-header">Détails des métadonnées:</div>
              <textarea *ngIf="traitement.metadata" readonly="true" rows="14"
                  style="width: 100%;">{{ traitement.metadata | xml }}</textarea>
          </div>
      </div>
  </dx-popup>
</ng-container>

<ng-template #noTraitement>
  <span>Aucun</span>
</ng-template>
